import { formatNumber } from "@/lib/api";
import { ExternalLink, Users, Eye, TrendingUp } from "lucide-react";

export const GameCard = ({ game, index = 0 }) => {
    return (
        <a
            href={game.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`game-card-${game.slug}`}
            className="card-lift group block rounded-2xl border border-white/10 bg-[#0F0A14] overflow-hidden fade-up"
            style={{ animationDelay: `${index * 100}ms` }}
        >
            <div className="relative aspect-[16/10] overflow-hidden bg-[#000000]">
                {game.icon ? (
                    <img
                        src={game.icon}
                        alt={game.name}
                        loading="lazy"
                        className="img-zoom w-full h-full object-cover"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-slate-600 text-sm">No image</div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#000000] via-[#000000]/20 to-transparent" />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/50 backdrop-blur-md border border-white/10 text-[11px] font-mono uppercase tracking-widest text-slate-200">
                    <span className="live-dot" /> Live
                </div>
                <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="inline-flex items-center gap-1 text-[11px] font-mono uppercase tracking-widest text-white/90 px-2.5 py-1 rounded-full bg-teal-500/90">
                        Play <ExternalLink className="w-3 h-3" />
                    </span>
                </div>
            </div>

            <div className="p-5">
                <h3 className="font-display font-bold text-lg text-white line-clamp-1">{game.name}</h3>
                {game.creator && (
                    <p className="text-xs text-slate-400 mt-0.5">by {game.creator}</p>
                )}

                <div className="mt-4 grid grid-cols-3 gap-2">
                    <div className="rounded-lg border border-white/10 bg-black/30 px-2.5 py-2">
                        <div className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-slate-400 font-mono">
                            <Users className="w-3 h-3" /> Live
                        </div>
                        <div className="font-mono font-bold text-lg text-teal-400 mt-0.5">
                            {formatNumber(game.playing)}
                        </div>
                    </div>
                    <div className="rounded-lg border border-white/10 bg-black/30 px-2.5 py-2">
                        <div className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-slate-400 font-mono">
                            <Eye className="w-3 h-3" /> Visits
                        </div>
                        <div className="font-mono font-bold text-lg text-teal-300 mt-0.5">
                            {formatNumber(game.visits)}
                        </div>
                    </div>
                    <div className="rounded-lg border border-white/10 bg-black/30 px-2.5 py-2">
                        <div className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-slate-400 font-mono">
                            <TrendingUp className="w-3 h-3" /> Peak
                        </div>
                        <div className="font-mono font-bold text-lg text-amber-300 mt-0.5">
                            {game.peakCcu != null ? formatNumber(game.peakCcu) : "—"}
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default GameCard;
